<template>
  <div :class="`kit-status-pill kit-status-${status}-bg kit-status-${status}-fc`">
    <span class="t3 -t_medium">{{ text }}</span>
  </div>
</template>

<script>
const KIT_STATUSES = [
  'archived',
  'canceled',
  'created',
  'delivered',
  'failed',
  'failed_delivery',
  'invalid',
  'new',
  'out_of_stock',
  'pending_order_retry',
  'returned_to_sender',
  'shipped',
];

export default {
  name: 'KitStatusPill',
  props: {
    status: {
      type: String,
      validator(value) {
        return KIT_STATUSES.indexOf(value) !== -1;
      },
      required: true,
    },
  },
  computed: {
    text() {
      return this.$t(`KIT_DELIVERY.STATUS.${this.status.toUpperCase()}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.kit-status-pill {
  border-radius: 0.5rem;
  display: flex;
  height: max-content;
  padding: 0.125rem 0.5rem;
}
</style>
